import { AlphaBBoxIcon } from './AlphaBBoxIcon';

/**
 * author: GreenTurtwig
 * id 057EDDAB-65B4-495C-A473-71F759BC6FD9
 * name alpha-b-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-b-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterBBoxIcon = AlphaBBoxIcon;
export default LetterBBoxIcon